export default __webpack_public_path__ + "static/media/sw_2.ca0a962e.png";